import React from "react";
import styles from "./EventExtra.module.scss";
import SwiperCore, { Autoplay, FreeMode, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import SwipeCalendar from "../SwipeCalendar/SwipeCalendar";
import CustomForm from "../CustomForm/CustomForm";
import WorkshopList from "../WorkshopList/WorkshopList";

const EventExtra = ({ event, properties }) => {
  return (
    <div className={styles.EventExtra}>
      <div className={styles.Header}>
        <div className={" " + styles.HeaderContent}>
          <div className={styles.MobileImage}>
            <img src={event.head.image_mobile} />
          </div>
          <div className={styles.Text}>
            <div className={styles.Type}>{event.head.type}</div>
            <div className={styles.Title}>{event.head.title}</div>
            <div className={styles.Subtitle} dangerouslySetInnerHTML={{__html: event.head.subtitle}}></div>
            <div className={styles.Description} dangerouslySetInnerHTML={{__html: event.head.short_desc }}></div>
          </div>
          <div className={styles.Image}>
            <img src={event.head.image_desktop} />
          </div>
        </div>
      </div>

      <div className={styles.CenterSection}>
        <div className={"centeredSection"}>
          <div dangerouslySetInnerHTML={{__html: event.central_section.text_1 }}></div>
          {event?.central_section.square_images && event?.central_section.square_images.length > 0 && <><div className={styles.SquareImages}>
            {event.central_section.square_images.map((image, i) => <img key={i} src={image} />)}
          </div>
          <div className={styles.SwipeImages}>
            <Swiper
              onInit={swiper => {swiper.slideTo(0, 0);}}
              pagination={{clickable: true, el: '.swipeImagesPagination'}}
              slidesPerView={2}
              modules={[Pagination]}
              spaceBetween={20}
              speed={2000}
              autoplay={{
                disableOnInteraction: false,
              }}
            >
              {event.central_section.square_images.map((d, i) => (
                <SwiperSlide key={i}>
                  <div className={styles.SwipeImage}>
                    <img src={d} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="swipeImagesPagination"></div>
          </div></>}
          <div dangerouslySetInnerHTML={{__html: event.central_section.text_2 }}></div>
        </div>
      </div>

      {event.repeatable_blocks && <div className={styles.Repeatable}>
        <div className={"centeredSection"}>
          {event.repeatable_blocks.map((block, i) => <div className={styles.Block} key={'bl_'+i} style={block.image ? {marginTop: 0} : {marginTop: 0}}>
            {block.image && <div className={styles.BlockFlex} style={{ justifyContent: !(block.title || block.subtitle || block.description) || !(block.image) ? 'center' : 'flex-end' }}>
              {block.link && <a href={block.link} target="_blank" rel="noreferrer">
                <div className={styles.BlockImage}>
                  <img src={block.image} />
                  {block.link_type == 'video' && <div className={styles.LinkTypeVideo}></div>}
                </div>
              </a>}
              {!block.link && <div className={styles.BlockImage}>
                  <img src={block.image} />
                </div>}
              {(block.title || block.subtitle || block.description) && <div className={styles.BlockDesc}>
                <div className={styles.BlockTitle}>{block.title}</div>
                <div className={styles.BlockSubtitle}>{block.subtitle}</div>
                <div dangerouslySetInnerHTML={{__html: block.description }}></div>
              </div>}
            </div>}
            <div className={styles.BlockText} dangerouslySetInnerHTML={{__html: block.text }}></div>
          </div>)}
        </div>
      </div>}

      {event.calendar && event.calendar.items.length > 0 && <div>
        <div style={{backgroundColor: '#312729', padding: '1px 0'}}>
        <SwipeCalendar items={event.calendar.items} calendarStyle="dark" />
        </div>
      </div>}

      {event.form && event.form.fields && event.form.fields.length > 0 && 
      <CustomForm dataContent={event.form} styletype="gold" />}

      {event.workshops?.services && event.workshops?.services?.length > 0 && <WorkshopList form_login={event.form_login} form_loyalty={event.form_loyalty} workshops={event.workshops} properties={properties} />}

    </div>
  );
};

export default EventExtra;
